import React, { useState } from 'react';

import { ChannelRow } from '../shared/popup-channels';
import PopupChannels from '../shared/popup-channels';
import SectionTitle from '../shared/section-titles';
import channels from '../../../channels.json';
import styled from 'styled-components';

const DOMAIN = 'https://netsurf.bg/';

const ChannelsSection = () => {
	const channelInfo = [
		{
			title: 'Най-гледани',
			channelData: channels.data.favourites.mostWatched.files.map((file) => {
				const PATH = 'tv-channels/favourites/Най-гледани/';
				return `${DOMAIN}${PATH}${file}`;
			})
		},
		{
			title: 'Филми/Сериали',
			channelData: channels.data.favourites.movies.files.map((file) => {
				const PATH = 'tv-channels/favourites/Филми Сериали/';
				return `${DOMAIN}${PATH}${file}`;
			})
		},
		{
			title: 'Спорт',
			channelData: channels.data.favourites.sports.files.map((file) => {
				const PATH = 'tv-channels/favourites/Спорт/';
				return `${DOMAIN}${PATH}${file}`;
			})
		},
		{
			title: 'Музика',
			channelData: channels.data.favourites.music.files.map((file) => {
				const PATH = 'tv-channels/favourites/Музика/';
				return `${DOMAIN}${PATH}${file}`;
			})
		},
		{
			title: 'За децата',
			channelData: channels.data.favourites.kids.files.map((file) => {
				const PATH = 'tv-channels/favourites/За децата/';
				return `${DOMAIN}${PATH}${file}`;
			})
		},
		{
			title: 'Документални',
			channelData: channels.data.favourites.hobbiesAndLifestyle.files.map((file) => {
				const PATH = 'tv-channels/favourites/Документални/';
				return `${DOMAIN}${PATH}${file}`;
			})
		},
		{
			title: 'HD',
			channelData: channels.data.favourites.HD.files.map((file) => {
				const PATH = 'tv-channels/favourites/HD/';
				return `${DOMAIN}${PATH}${file}`;
			})
		}
	];

	return (
		<>
			<section id="channels" className="centering spacing-top"></section>
			<div className="row">
				<SectionTitle>
					<h2>
						Любимата ти телевизия
						<br />
						от всеки жанр
					</h2>
					<hr className="center" />
				</SectionTitle>

				<div className="container mt-4">
					<TabularSection channels={channelInfo} />
				</div>
			</div>
		</>
	);
};

const ScrollChannels = styled.div`
	overflow-x: scroll;
	overflow-y: hidden;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;
	&::-webkit-scrollbar {
		display: none;
	}
`;

const Item = styled.div`
	display: inline-block;
`;

const TabularSection = ({ channels }) => {
	const [selectedTab, setTab] = useState(0);
	const [show, setShow] = useState(false);

	return (
		<div>
			<ScrollChannels>
				{channels.map(({ title }, index) => (
					<Item key={index}>
						<button
							className={
								'clear channel-selection px-4 d-inline-block ' +
								(selectedTab === index && 'active')
							}
							onClick={(e) => {
								setTab(index);
							}}
						>
							<h3 className="d-inline-block">{title}</h3>
						</button>
					</Item>
				))}
			</ScrollChannels>
			<div className="my-4 text-center">
				<ChannelRow channels={channels[selectedTab].channelData} />
				<button
					onClick={(_) => setShow(true)}
					type="button"
					className="btn btn-secondary-no-outline mt-5"
				>
					Виж целия списък
				</button>
			</div>

			<PopupChannels
				show={show}
				setShow={(v) => {
					setShow(v);
				}}
			/>
		</div>
	);
};

export default ChannelsSection;

